import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DialogMargins, DialogService, DialogSizes } from '../../dialog.service';

import { ConfirmationModalData } from './confirmation-modal-data';
import { ConfirmationModalComponent } from './confirmation-modal.component';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
    constructor(private readonly modalService: DialogService) {}

    public show(data: ConfirmationModalData, category?: string, icon?: string): Observable<boolean> {
        // Valores por defecto
        // eslint-disable-next-line no-param-reassign
        if (typeof data.showCancel !== 'boolean') data.showCancel = true;
        // eslint-disable-next-line no-param-reassign
        if (!data.confirm) data.confirm = 'dev.general.accept';
        // eslint-disable-next-line no-param-reassign
        if (!data.cancel) data.cancel = 'dev.general.cancel';
        return this.modalService
            .openModalFromComponent(
                data.title,
                ConfirmationModalComponent,
                data,
                DialogSizes.SIZE_XS,
                DialogMargins.MARGIN_24,
                null,
                category,
                icon
            )
            .afterClosed$.pipe(map((result) => result.data as boolean));
    }
}
